"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pisogne": {
    "0e7117f9": [{
      "hkey": "cb703d86",
      "slug": "pisogne",
      "name": "Pisogne",
      "primary": true,
      "skipSearch": false
    }],
    "boschetta": [{
      "hkey": "cb703d86",
      "slug": "pisogne",
      "name": "Pisogne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "392f87f7": [{
      "hkey": "cb703d86",
      "slug": "pisogne",
      "name": "Pisogne",
      "primary": true,
      "skipSearch": false
    }],
    "passabocche": [{
      "hkey": "cb703d86",
      "slug": "pisogne",
      "name": "Pisogne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "afd6d4b2": [{
      "hkey": "5950ff7b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pieve": [{
      "hkey": "5950ff7b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pisogne"
    }],
    "d8079545": [{
      "hkey": "cb703d86",
      "slug": "pisogne",
      "name": "Pisogne",
      "primary": true,
      "skipSearch": false
    }],
    "pitinghello": [{
      "hkey": "cb703d86",
      "slug": "pisogne",
      "name": "Pisogne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "182e9d7b": [{
      "hkey": "cb703d86",
      "slug": "pisogne",
      "name": "Pisogne",
      "primary": true,
      "skipSearch": false
    }],
    "renzo": [{
      "hkey": "cb703d86",
      "slug": "pisogne",
      "name": "Pisogne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9233a053": [{
      "hkey": "cb703d86",
      "slug": "pisogne",
      "name": "Pisogne",
      "primary": true,
      "skipSearch": false
    }],
    "rovina": [{
      "hkey": "cb703d86",
      "slug": "pisogne",
      "name": "Pisogne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;